var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "zendesk-wrapper" }, [
    _c("a", { attrs: { href: _vm.zendeskLineAccountURL } }, [
      _c("img", {
        attrs: {
          src: "https://scdn.line-apps.com/n/line_add_friends/btn/en.png",
          alt: "Add friend",
          height: "36",
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }